import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.65, ease: 'easeOut' },
  },
};

export default function Testimonials() {
  return (
    <div style={{ backgroundColor: '#0A0F1C' }}>
      {/* Page header */}
      <section
        className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 text-center"
        style={{ backgroundColor: '#070C18', borderBottom: '1px solid rgba(204,0,0,0.2)' }}
      >
        <motion.div initial="hidden" animate="visible" variants={fadeUp}>
          <p className="text-xs font-semibold uppercase tracking-widest mb-3" style={{ color: '#CC0000' }}>
            Customer Reviews
          </p>
          <h1
            className="text-5xl sm:text-6xl font-bold text-white mb-4"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            What Our Customers Say
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Highly rated on Google and 100% recommended on Facebook. Here is what the Kapiti Coast community thinks of Auto Doctor.
          </p>
        </motion.div>
      </section>

      {/* Reputation badges */}
      <section style={{ backgroundColor: '#0D1220', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <motion.div
              className="rounded-xl p-6 flex items-center gap-4"
              style={{ backgroundColor: '#0A0F1C', border: '1px solid rgba(204,0,0,0.25)' }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeUp}
            >
              <div className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(204,0,0,0.15)' }}>
                <svg className="w-6 h-6" style={{ fill: '#CC0000' }} viewBox="0 0 24 24">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                </svg>
              </div>
              <div>
                <p className="text-white font-bold text-lg" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                  Highly Rated on Google
                </p>
                <p className="text-gray-400 text-sm">Trusted by Kapiti Coast drivers</p>
              </div>
            </motion.div>

            <motion.div
              className="rounded-xl p-6 flex items-center gap-4"
              style={{ backgroundColor: '#0A0F1C', border: '1px solid rgba(204,0,0,0.25)' }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeUp}
            >
              <div className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(204,0,0,0.15)' }}>
                <svg className="w-6 h-6 fill-current" style={{ color: '#CC0000' }} viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </div>
              <div>
                <p className="text-white font-bold text-lg" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                  100% Recommended on Facebook
                </p>
                <p className="text-gray-400 text-sm">Local community approved</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Google review cards */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

            {/* Card 1 - Sarah Haworth */}
            <motion.div
              className="rounded-2xl p-7 flex flex-col"
              style={{ backgroundColor: '#0A0F1C', border: '1px solid rgba(204,0,0,0.35)' }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              custom={0}
              variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0, ease: 'easeOut' } } }}
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <p className="text-white font-semibold text-base">Sarah Haworth</p>
                  <div className="flex gap-0.5 mt-1">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="w-4 h-4" style={{ fill: '#F5A623' }} viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                </div>
                <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                </svg>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed italic flex-grow">
                "Had these guys service my car today and put it through a WOF. Great service and good price. Would recommend, helpful, friendly and they dropped my car back off at work for me."
              </p>
            </motion.div>

            {/* Card 2 - Mike Cooksley */}
            <motion.div
              className="rounded-2xl p-7 flex flex-col"
              style={{ backgroundColor: '#0A0F1C', border: '1px solid rgba(204,0,0,0.35)' }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              custom={1}
              variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.1, ease: 'easeOut' } } }}
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <p className="text-white font-semibold text-base">Mike Cooksley</p>
                  <div className="flex gap-0.5 mt-1">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="w-4 h-4" style={{ fill: '#F5A623' }} viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                </div>
                <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                </svg>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed italic flex-grow">
                "Really great mechanics, friendly helpful team including reception. Have used these guys for both work and personal vehicles for years. Highly recommend."
              </p>
            </motion.div>

            {/* Card 3 - Virginia Green */}
            <motion.div
              className="rounded-2xl p-7 flex flex-col"
              style={{ backgroundColor: '#0A0F1C', border: '1px solid rgba(204,0,0,0.35)' }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              custom={2}
              variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.2, ease: 'easeOut' } } }}
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <p className="text-white font-semibold text-base">Virginia Green</p>
                  <div className="flex gap-0.5 mt-1">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="w-4 h-4" style={{ fill: '#F5A623' }} viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                </div>
                <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                </svg>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed italic flex-grow">
                "Called into Auto Doctor because our engine light came on saying we'd overfilled our diesel engine with oil. Mike was fantastic and sucked out the excess. Thanks Mike!"
              </p>
            </motion.div>

            {/* Card 4 - CTA */}
            <motion.div
              className="rounded-2xl p-7 flex flex-col items-center justify-center text-center"
              style={{ backgroundColor: '#0A0F1C', border: '1px solid rgba(204,0,0,0.35)' }}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              custom={3}
              variants={{ hidden: { opacity: 0, y: 40 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.3, ease: 'easeOut' } } }}
            >
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-5 h-5" style={{ fill: '#F5A623' }} viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              <p
                className="text-white text-xl font-bold mb-2"
                style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
              >
                Highly Rated on Google
              </p>
              <p className="text-gray-400 text-sm mb-6 leading-relaxed">
                See what the Kapiti Coast community says about Auto Doctor.
              </p>
              <a
                href="https://search.google.com/local/reviews?placeid=ChIJj7vHTvWiQG0Rqwv9YOVCfX4"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-6 py-3 font-semibold text-white rounded text-sm transition-all duration-200"
                style={{ backgroundColor: '#CC0000' }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#AA0000'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#CC0000'; }}
              >
                Read All Our Reviews
              </a>
            </motion.div>

          </div>

          {/* Verified link */}
          <p className="text-center text-gray-500 text-xs mt-6">
            <a
              href="https://search.google.com/local/reviews?placeid=ChIJj7vHTvWiQG0Rqwv9YOVCfX4"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300 transition-colors duration-200 underline underline-offset-2"
            >
              Verified Google Reviews
            </a>
          </p>
        </div>
      </section>

      {/* Additional trust content */}
      <section style={{ backgroundColor: '#070C18', borderTop: '1px solid rgba(204,0,0,0.2)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <motion.div
            className="text-center mb-12"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUp}
          >
            <h2
              className="text-4xl sm:text-5xl font-bold text-white mb-4"
              style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
            >
              Why Customers Keep Coming Back
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              { label: 'Honest Advice', desc: 'We only recommend what your vehicle genuinely needs.' },
              { label: 'Fair Pricing', desc: 'Transparent quotes with no hidden costs or nasty surprises.' },
              { label: 'Local Knowledge', desc: 'We know the roads and conditions of the Kapiti Coast.' },
            ].map((item, i) => (
              <motion.div
                key={i}
                className="text-center p-8 rounded-xl"
                style={{ backgroundColor: '#0D1220', border: '1px solid rgba(255,255,255,0.06)' }}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                custom={i}
                variants={{
                  hidden: { opacity: 0, y: 40 },
                  visible: {
                    opacity: 1,
                    y: 0,
                    transition: { duration: 0.6, delay: i * 0.12, ease: 'easeOut' },
                  },
                }}
              >
                <div className="text-3xl font-bold mb-3" style={{ fontFamily: "'Barlow Condensed', sans-serif", color: '#CC0000' }}>
                  {item.label}
                </div>
                <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
